export type HexColor = `#${string}`;

export const getDarkestColor = (colorOne: HexColor, colorTwo: HexColor) => {
	const colorOneValue = parseInt(colorOne.replace('#', ''), 16);
	const colorTwoValue = parseInt(colorTwo.replace('#', ''), 16);

	return colorOneValue < colorTwoValue ? colorOne : colorTwo;
};

export const getLightestColor = (colorOne: HexColor, colorTwo: HexColor) =>
	getDarkestColor(colorOne, colorTwo) === colorOne ? colorTwo : colorOne;
